export const limitedCompanyChanges = {
    heading: 'limited-company-changes-page-heading',
    sectionHeading: 'limited-company-changes-section-heading',
};